import React from 'react';
import Banner from "../../assets/images/baner2.jpg"
import { Link } from 'react-router-dom';

const BannerSection = () => {
  return (
    <div className="relative h-96 overflow-hidden">
      <img
        src={Banner}
        alt="Motorcycle banner"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center max-w-xl px-4">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-white">Koleksioni i ri 2023</h2>
          <p className="text-white md:text-lg mb-6">Zbulo veshjet dhe aksesorët e rinj të sezonit për motoristët e vërtetë.</p>
          <Link to="/products" className="px-8 py-3 bg-[#D0112B] text-white uppercase text-sm font-medium tracking-wide">
            Zbulo më shumë
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BannerSection;